const CATEGORY_ROUTES = {
    ADD_CATEGORY: 'categories/add',
    GET_CATEGORY: 'categories/list',
    UPDATE_CATEGORY: 'categories/update',
    DELETE_CATEGORY: 'categories/delete',
    LIST_CATEGORY_CLUSTER: 'category-cluster/list',
}
export default CATEGORY_ROUTES;